module.exports = __webpack_public_path__ + "static/media/exclamation-circle.0c5d8ee5.svg";